
import React,{Component} from 'react';
import './CreateClientLocaton.css';
import searchbule from '../../../../image/searchbule.svg'
import MapsNewOrder from '../../../Components/Maps/MapsNewOrder';
import Loading from '../../Components/Loading/Loading';

class CreateClientLocaton extends Component{
    render(){
        return(
            <div className="CreateCientLocation">
               <form onSubmit={this.props.handleSubmitCreateLocation}>
                   
            
               <div className="col-12 text-center ">
               <MapsNewOrder  key={this.props.state.res_done}  setStatecoordinatesaddress_alias={this.props.setStatecoordinatesaddress_alias} state={this.props.state} />

               <div className="col-md-8 text-center">
                        <div className="form-group pb-0 mb-1 search_div"id="pac-container">
                        <img className="ml-1  img_input" src={searchbule} alt="search"  />
                            <input type="text " id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.props.state.address_nameError ? 'is-invalid' : '')} placeholder="اختار عنوان  "  name="address_name" value={this.props.state.address_name} onChange={this.props.handleChange} required/>
                                  
                        </div>
                        <div style={{ fontSize: 12, color: "red" }} className="text-right">
                            {this.props.state.address_nameError}
                        </div> 
                        <div id="map"></div>
                        <div className="form-group col-12 text-right mt-2">
                        <label >تفاصيل للعنوان</label>
                        <input type="text" className={"form-control badge-pill p-3 " + (this.props.state.address_aliasError ? 'is-invalid' : '')} placeholder="الشقه - الدور - العماره .." name="address_alias" value={this.props.state.address_alias} onChange={this.props.handleChange} required  />
                        <div style={{ fontSize: 12, color: "red" }}>
                            {this.props.state.address_aliasError}
                        </div>                
                    </div>
                    </div> 
               </div>

                <button type="submit" className="text-white badge-pill p-2 pl-1 px-3 border shadow bluebg text-center m-3" disabled={(this.props.state.inRequest?true:false)}>حفظ</button>
                </form>
            </div>
        )
    }
}
export default CreateClientLocaton;
